import { Component, Inject, OnInit } from '@angular/core';
import { CovidMetaDataItemNames, EmployeeTestEntity, EmployeeVaccinationSubmissionEntity } from '../../meta-data/covid-meta-data.service';
import { areEqual, deepCopy, DwComponent, DwComponentType, DwExpressionService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, formatDateTime } from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';


import * as moment_ from 'moment';
import { validateClaimsRequest } from 'msal/lib-commonjs/AuthenticationParameters';
import { CovidTestStatus } from '../../meta-data/covid-test-status.enum';
import { registerRequestInstrumentation } from '@sentry/tracing';
const moment = moment_;

@DwComponent({
  key:'covidTesting',
  name: 'Covid Testing',
  componentType: DwComponentType.formSection,
  parentItemName: [CovidMetaDataItemNames.EmployeeTest,CovidMetaDataItemNames.EmployeeVaccinationSubmission],
  isGlobal: false
})
@Component({
  selector: 'app-covid-test',
  template:``
})
export class CovidTestComponent extends DwSectionBaseComponent {

  constructor(private dwSecurityUserService: DwSecurityUserService,
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  private lastTest: EmployeeTestEntity | EmployeeVaccinationSubmissionEntity;

  ngOnInit(): void {
    super.ngOnInit();

    this.formGroup.valueChanges
      .pipe(debounceTime(50))  // Wait 250 ms before performing checks
      .subscribe(value => {
        this.handleFormChange(this.formGroup.getRawValue());
      });
  }



  private handleFormChange(test: EmployeeTestEntity| EmployeeVaccinationSubmissionEntity) {
    const currentStatusId = this.getStatusValue(test);

    let forceUpdate = false;

    if (!test || this.getStatusValue(this.lastTest) == currentStatusId) {
      this.lastTest = deepCopy(test);
      return;
    }

    if (!currentStatusId && test) {
      if (this.isEmployeeTest(test)) {
          test.CovidTestStatusId = CovidTestStatus.pending;
      } else {
          test.CovidVaccinationSubmissionStatusId = CovidTestStatus.pending;
      }

      forceUpdate = true;
    }

    if(!test.EmployeeUserId) {
      test.EmployeeUserId = this.getTrustUserId();

      if (this.isEmployeeTest(test)) {
        if (!test.TestDateTime) {
          test.TestDateTime = this.getCurrentDateTime();
        } 
      } else {
        if (!test.SubmittedDateTime) {
          test.SubmittedDateTime = this.getCurrentDateTime();
        }
      }

      forceUpdate = true;
    }

    if(currentStatusId == CovidTestStatus.verified) {
       if (!test.VerifiedByUserId || !test.VerifiedDateTime) {
        test.VerifiedDateTime = this.getCurrentDateTime();
        test.VerifiedByUserId = this.getTrustUserId();
        test.RejectedDateTime = null;
        test.RejectedByUserId = null;

        forceUpdate = true;
      } 
    }

    if(currentStatusId == CovidTestStatus.rejected) {
      if (!test.RejectedByUserId || !test.RejectedDateTime) {
        test.RejectedDateTime = this.getCurrentDateTime();
        test.RejectedByUserId = this.getTrustUserId();

        test.VerifiedDateTime = null;
        test.VerifiedByUserId = null;

        forceUpdate = true;
      }
    }

    if(currentStatusId == CovidTestStatus.pending) {

      if (test.RejectedDateTime || test.RejectedByUserId || test.VerifiedDateTime || test.VerifiedByUserId) {
        test.RejectedDateTime = null;
        test.RejectedByUserId = null;

        test.VerifiedDateTime = null;
        test.VerifiedByUserId = null;

        forceUpdate = true;

        return;
      }
    }

    if (forceUpdate) {
      this.updateForm(test);
    }
  }


  getStatusValue(test: EmployeeTestEntity | EmployeeVaccinationSubmissionEntity) {

    if (this.isEmployeeTest(test)) {
      return test?.CovidTestStatusId;
    }

    return test?.CovidVaccinationSubmissionStatusId;
  }

  private isEmployeeTest(test: EmployeeTestEntity | EmployeeVaccinationSubmissionEntity) : test is EmployeeTestEntity {

    const employeeTest = test as EmployeeTestEntity;

    if (employeeTest?.CovidTestStatusId) {
      return true;
    }

    return false;
  }
    
  private getCurrentDateTime(): string {
    let dateTimeStr =  moment().utc().format("MM/DD/YYYY hh:mm A")

    return dateTimeStr;
  }

  private getTrustUserId() {
    const user = this.dwSecurityUserService.securityContext.ApplicationUser;

    if (user) {
      const wachterUser = new WachterUserExt(user);

      return wachterUser.trustUserId;
    }

    return null;
  }

  private updateForm(test: EmployeeTestEntity) {

    if (this.isEmployeeTest(test)) {
      test.IsProcessed = false;
    }

    if (areEqual(test, this.lastTest)) {
      return;
    }

    this.lastTest = deepCopy(test);

    this.formGroup.patchValue(test);

  }

}
